import React, { useId } from 'react';
import { Card, Spin, Typography } from 'antd';
import type {
  AdminProductCreateCardProps,
} from '../../interfaces';
import AdminProductCreateForm from '../AdminProductCreateForm';
import './AdminProductCreateCard.scss';

const { Title } = Typography;

const AdminProductCreateCard: React.FC<AdminProductCreateCardProps> = ({
  form,
  types,
  materialTemplates,
  filteredSizes,
  selectedTypeRequiresSizes,
  loadingOptions,
  submitting,
  isOpen,
  createCardRef,
  onSubmit,
  onToggleOpen,
  alwaysOpen = false,
}) => {
  const bodyId = useId();
  const titleId = useId();

  return (
    <Card
      ref={createCardRef}
      className={`admin-product-form__card ${!isOpen && !alwaysOpen ? 'is-collapsed' : ''}`}
    >
      <div className="admin-product-form__create-header">
        <Title id={titleId} level={4}>Create Product</Title>
        {!alwaysOpen && (
          <button
            type="button"
            className="admin-product-form__toggle"
            aria-expanded={isOpen}
            aria-controls={bodyId}
            onClick={() => onToggleOpen((prev) => !prev)}
          >
            {isOpen ? 'Hide Product Form' : 'Open Product Form'}
          </button>
        )}
      </div>
      {isOpen && loadingOptions && (
        <div className="admin-product-form__loader">
          <Spin />
        </div>
      )}
      <div
        id={bodyId}
        className={`admin-product-form__create-body ${!isOpen || loadingOptions ? 'is-hidden' : ''}`}
        role="region"
        aria-labelledby={titleId}
        aria-hidden={!isOpen || loadingOptions}
      >
        <AdminProductCreateForm
          form={form}
          types={types}
          materialTemplates={materialTemplates}
          filteredSizes={filteredSizes}
          selectedTypeRequiresSizes={selectedTypeRequiresSizes}
          submitting={submitting}
          onSubmit={onSubmit}
        />
      </div>
    </Card>
  );
};

export default AdminProductCreateCard;
